var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/localization.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["navItem", "prefix", "suffix"], 
[], 
function (l_navItem, l_prefix, l_suffix, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItem", l_navItem);
frame.set("prefix", l_prefix);
frame.set("suffix", l_suffix);
var t_2 = "";if(l_navItem) {
var t_3;
t_3 = env.getFilter("lower").call(context, runtime.memberLookup((l_navItem),"type"));
frame.set("coercedNavItemType", t_3, true);
if(frame.topLevel) {
context.setVariable("coercedNavItemType", t_3);
}
if(frame.topLevel) {
context.addExport("coercedNavItemType", t_3);
}
if(runtime.contextOrFrameLookup(context, frame, "coercedNavItemType") == "gateway" || runtime.contextOrFrameLookup(context, frame, "coercedNavItemType") == "landing") {
var t_4;
t_4 = l_prefix + "" + "-" + "" + runtime.contextOrFrameLookup(context, frame, "coercedNavItemType") + "" + "-" + "" + l_suffix;
frame.set("slug", t_4, true);
if(frame.topLevel) {
context.setVariable("slug", t_4);
}
if(frame.topLevel) {
context.addExport("slug", t_4);
}
;
}
else {
if(runtime.memberLookup((l_navItem),"nestLevel")) {
var t_5;
t_5 = l_prefix + "" + "-L" + "" + runtime.memberLookup((l_navItem),"nestLevel") + "" + "-" + "" + l_suffix;
frame.set("slug", t_5, true);
if(frame.topLevel) {
context.setVariable("slug", t_5);
}
if(frame.topLevel) {
context.addExport("slug", t_5);
}
;
}
else {
var t_6;
t_6 = l_prefix + "" + "-" + "" + l_suffix;
frame.set("slug", t_6, true);
if(frame.topLevel) {
context.setVariable("slug", t_6);
}
if(frame.topLevel) {
context.addExport("slug", t_6);
}
;
}
;
}
;
}
else {
var t_7;
t_7 = l_prefix + "" + "-" + "" + l_suffix;
frame.set("slug", t_7, true);
if(frame.topLevel) {
context.setVariable("slug", t_7);
}
if(frame.topLevel) {
context.addExport("slug", t_7);
}
;
}
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "slug"), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("generate_localization_slug_for_nav_item");
context.setVariable("generate_localization_slug_for_nav_item", macro_t_1);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
["originalSlug", "language"], 
["slugFieldName", "state"], 
function (l_originalSlug, l_language, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("originalSlug", l_originalSlug);
frame.set("language", l_language);
frame.set("slugFieldName", kwargs.hasOwnProperty("slugFieldName") ? kwargs["slugFieldName"] : "slug");
frame.set("state", kwargs.hasOwnProperty("state") ? kwargs["state"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_9 = "";var t_10;
t_10 = env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "state"),(env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "core"),{},true)),true);
frame.set("reduxCore", t_10, true);
if(frame.topLevel) {
context.setVariable("reduxCore", t_10);
}
if(frame.topLevel) {
context.addExport("reduxCore", t_10);
}
var t_11;
t_11 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "reduxCore")),"flatNavigation")),l_originalSlug);
frame.set("navItem", t_11, true);
if(frame.topLevel) {
context.setVariable("navItem", t_11);
}
if(frame.topLevel) {
context.addExport("navItem", t_11);
}
if(runtime.contextOrFrameLookup(context, frame, "navItem") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"links") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"links")) > 0) {
var t_12;
t_12 = env.getFilter("default").call(context, env.getFilter("first").call(context, env.getFilter("selectattr").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"links"),"locale","equalto",l_language)),runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("localizedLink", t_12, true);
if(frame.topLevel) {
context.setVariable("localizedLink", t_12);
}
if(frame.topLevel) {
context.addExport("localizedLink", t_12);
}
if(runtime.contextOrFrameLookup(context, frame, "localizedLink")) {
var t_13;
t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "localizedLink")),runtime.contextOrFrameLookup(context, frame, "slugFieldName"));
frame.set("slug", t_13, true);
if(frame.topLevel) {
context.setVariable("slug", t_13);
}
if(frame.topLevel) {
context.addExport("slug", t_13);
}
;
}
else {
var t_14;
t_14 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),runtime.contextOrFrameLookup(context, frame, "slugFieldName"));
frame.set("slug", t_14, true);
if(frame.topLevel) {
context.setVariable("slug", t_14);
}
if(frame.topLevel) {
context.addExport("slug", t_14);
}
;
}
;
}
else {
var t_15;
t_15 = l_originalSlug;
frame.set("slug", t_15, true);
if(frame.topLevel) {
context.setVariable("slug", t_15);
}
if(frame.topLevel) {
context.addExport("slug", t_15);
}
;
}
t_9 += runtime.suppressValue(env.getFilter("trim").call(context, runtime.contextOrFrameLookup(context, frame, "slug")), env.opts.autoescape);
t_9 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
context.addExport("localized_slug_for_flat_nav_slug");
context.setVariable("localized_slug_for_flat_nav_slug", macro_t_8);
output += "\n\n";
var macro_t_16 = runtime.makeMacro(
["product", "language"], 
["slugFieldName"], 
function (l_product, l_language, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("product", l_product);
frame.set("language", l_language);
frame.set("slugFieldName", kwargs.hasOwnProperty("slugFieldName") ? kwargs["slugFieldName"] : "productSlug");
var t_17 = "";if(l_product && runtime.memberLookup((l_product),"links") && env.getFilter("length").call(context, runtime.memberLookup((l_product),"links")) > 0) {
var t_18;
t_18 = env.getFilter("default").call(context, env.getFilter("first").call(context, env.getFilter("selectattr").call(context, runtime.memberLookup((l_product),"links"),"locale","equalto",l_language)),runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("localizedLink", t_18, true);
if(frame.topLevel) {
context.setVariable("localizedLink", t_18);
}
if(frame.topLevel) {
context.addExport("localizedLink", t_18);
}
if(runtime.contextOrFrameLookup(context, frame, "localizedLink")) {
var t_19;
t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "localizedLink")),runtime.contextOrFrameLookup(context, frame, "slugFieldName"));
frame.set("slug", t_19, true);
if(frame.topLevel) {
context.setVariable("slug", t_19);
}
if(frame.topLevel) {
context.addExport("slug", t_19);
}
;
}
else {
var t_20;
t_20 = runtime.memberLookup((l_product),runtime.contextOrFrameLookup(context, frame, "slugFieldName"));
frame.set("slug", t_20, true);
if(frame.topLevel) {
context.setVariable("slug", t_20);
}
if(frame.topLevel) {
context.addExport("slug", t_20);
}
;
}
;
}
else {
var t_21;
t_21 = runtime.memberLookup((l_product),runtime.contextOrFrameLookup(context, frame, "slugFieldName"));
frame.set("slug", t_21, true);
if(frame.topLevel) {
context.setVariable("slug", t_21);
}
if(frame.topLevel) {
context.addExport("slug", t_21);
}
;
}
t_17 += runtime.suppressValue(env.getFilter("trim").call(context, runtime.contextOrFrameLookup(context, frame, "slug")), env.opts.autoescape);
t_17 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
context.addExport("localized_slug_for_product");
context.setVariable("localized_slug_for_product", macro_t_16);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/localization.j2"] , dependencies)